let _counter = 0;
class AdpCheckboxController {
  constructor() {
      this.name = 'adpCheckbox';
      this.id = 'checkbox_' + (_counter++);
  }
}

export default AdpCheckboxController;



// WEBPACK FOOTER //
// ./src/app/components/adpCheckbox/adpCheckbox.controller.js